/**
 * 画面共通のローディング状態管理サービス
 */

import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  /** 内部カウンター（複数同時リクエスト対応） */
  private readonly counter = signal(0);

  /** ローディング中かどうか */
  readonly loading = computed(() => this.counter() > 0);

  /** ローディング開始 */
  start(): void {
    this.counter.update(c => c + 1);
  }

  /** ローディング終了 */
  stop(): void {
    this.counter.update(c => Math.max(0, c - 1));
  }

  /** 強制リセット */
  reset(): void {
    this.counter.set(0);
  }
}
